module.exports = __webpack_public_path__ + "img/liouliangji0.prt.936a07ae.jpg";